var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "terms-of-use-pdf-viewer",
      class: { "terms-of-use-pdf-viewer--fullscreen": _vm.isFullscreen },
    },
    [
      _c(
        "div",
        { staticClass: "terms-of-use-pdf-viewer__toolbar" },
        [
          !_vm.error && _vm.totalPages > 0
            ? _c(
                "div",
                { staticClass: "terms-of-use-pdf-viewer__nav-group" },
                [
                  _c(
                    "span",
                    { staticClass: "terms-of-use-pdf-viewer__nav-label" },
                    [_vm._v(" " + _vm._s(_vm.$t("pagina")) + " ")]
                  ),
                  _c("b-form-select", {
                    staticClass: "terms-of-use-pdf-viewer__page-select",
                    attrs: {
                      options: _vm.pageOptions,
                      title: _vm.$t("pagina"),
                      "aria-label": _vm.$t("pagina"),
                    },
                    on: { change: _vm.scrollToPage },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.isFullscreen && !_vm.error && _vm.totalPages > 0
            ? _c(
                "div",
                { staticClass: "terms-of-use-pdf-viewer__zoom-group" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "light",
                        size: "sm",
                        disabled: _vm.zoomFactor <= _vm.minZoom,
                        "aria-label": _vm.$t("diminuirzoom"),
                      },
                      on: { click: _vm.zoomOut },
                    },
                    [_vm._v(" - ")]
                  ),
                  _c(
                    "span",
                    { staticClass: "terms-of-use-pdf-viewer__zoom-level" },
                    [_vm._v(" " + _vm._s(_vm.zoomPercentage) + "% ")]
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "light",
                        size: "sm",
                        disabled: _vm.zoomFactor >= _vm.maxZoom,
                        "aria-label": _vm.$t("aumentarzoom"),
                      },
                      on: { click: _vm.zoomIn },
                    },
                    [_vm._v(" + ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "b-button",
            {
              staticClass: "terms-of-use-pdf-viewer__fullscreen-btn",
              attrs: {
                variant: "none",
                title: _vm.isFullscreen
                  ? _vm.$t("sairtelacheia")
                  : _vm.$t("telacheia"),
              },
              on: { click: _vm.toggleFullscreen },
            },
            [
              _c("svg-icon", {
                attrs: {
                  "icon-class": _vm.isFullscreen
                    ? "exit-fullscreen"
                    : "fullscreen",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          ref: "scrollContainer",
          staticClass: "terms-of-use-pdf-viewer__document",
        },
        [
          _vm.error
            ? _c("div", { staticClass: "terms-of-use-pdf-viewer__error" }, [
                _vm._v(" " + _vm._s(_vm.$t("erroaocarregarpdf")) + " "),
              ])
            : _vm._l(_vm.pages, function (page) {
                return _c(
                  "figure",
                  {
                    key: page.number,
                    ref: "pageEls",
                    refInFor: true,
                    staticClass: "terms-of-use-pdf-viewer__page",
                    class: {
                      "terms-of-use-pdf-viewer__page--current":
                        page.number === _vm.currentPage,
                    },
                    style: _vm.pageStyle(page),
                    attrs: {
                      "data-page": page.number,
                      "aria-label": _vm.pageAriaLabel(page),
                    },
                  },
                  [
                    _c("canvas", {
                      staticClass: "terms-of-use-pdf-viewer__canvas",
                    }),
                  ]
                )
              }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }